module.exports = __webpack_public_path__ + "img/pass-it-down-desktop_676x500.09809167.jpg";